import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Constant, FormatDateEnum } from 'app/config/constants';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translateService: TranslateService, private datePipe: DatePipe) {}

  public transform(value: any): any {
    const formatDate = this.getFormatDateByLanguage();
    if (value) {
      return this.datePipe.transform(value, formatDate);
    }
  }

  /**
   * get format date by language
   * @returns
   */
  private getFormatDateByLanguage(): string {
    switch (this.translateService.currentLang) {
      case Constant.JP_LANGUAGE:
        return FormatDateEnum.FORMAT_JP;
      case Constant.EN_LANGUAGE:
        return FormatDateEnum.FORMAT_EN;
      default:
        break;
    }
  }
}
